export enum SetupIntentStatus {
  Succeeded = 'succeeded',
  Processing = 'processing',
  Canceled = 'canceled',
  Failed = 'failed'
}

export enum PaymentIntentStatus {
  Succeeded = 'succeeded',
  Processing = 'processing',
  Canceled = 'canceled',
  RequiresPaymentMethod = 'requires_payment_method'
}
